import { tmrLoginController } from './login.controller'
import './login.scss'
import templateUrl from './login.html'

export { tmrLoginController }

/**
 * User login route.
 *
 * @namespace routes.Login
 * @type {TmrRoute}
 */
export const route = {
  name: 'login',
  label: 'LOGIN.TITLE',
  url: '/login',
  component: 'tmrLogin',
  accessControl: [],
  accessAnonymous: true,
  resolve: {
    loginAs: () => false,
  },
}

/**
 * User login component.
 *
 * @type {ngComponent}
 */
export const tmrLogin = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrLoginController',
  bindings: {
    loggedUser: '<',
    loginAs: '<',
    onSubmit: '&?',
  },
}
